// import mixins from './../_mixins-missmatch-monitor';
import methods from './_methods';

export default {
    name: 'TableProductsAvailable',
    methods,
    watch: {
        // Watcher para comprobar si se ha seleccionado un radiobutton o no
        // y así marcar la fila como seleccionada en el array de items.
        selected() {
            const value = this.selected;
            const indexSelected = value.split('product__row__');
            this.itemsFormated.forEach(el => (el.selected = false));
            this.itemsFormated[indexSelected[1]].selected = true;
            this.$root.$emit('productSelected', this.itemsFormated[indexSelected[1]].productKey);
        }
    },
    data() {
        return {
            selected: ''
        };
    },
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    computed: {
        // Formateamos los datos recibidos desde el componente padre
        itemsFormated() {
            return this.items
                .filter(item => item.yuri_shares || item.rd_shares)
                .map(x => ({
                    selected: false,
                    productName: x.name_product,
                    productKey: x.key_product,
                    dateLastMissmatch: x.last_match_date, // Falta este campo desde el back
                    participationsYuri: x.yuri_shares,
                    participationsRd: x.rd_shares,
                    difference: x.difference
                }));
        },
        // Columnas que queremos mostrar en la tabla
        fields() {
            return ['productName', 'dateLastMissmatch', 'participationsYuri', 'participationsRd', 'difference'];
        }
    }
};
